module.exports = __webpack_public_path__ + "static/img/fre_tip_fr.396d921.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/fre_tip_fr.png
// module id = XWE3
// module chunks = 0